import EntryActionTypes from '../../constants/EntryActionTypes';

export const createLabelInCurrentSite = (data) => ({
  type: EntryActionTypes.LABEL_IN_CURRENT_SITE_CREATE,
  payload: {
    data,
  },
});

export const updateLabel = (id, data) => ({
  type: EntryActionTypes.LABEL_UPDATE,
  payload: {
    id,
    data,
  },
});

export const deleteLabel = (id) => ({
  type: EntryActionTypes.LABEL_DELETE,
  payload: {
    id,
  },
});

export const addLabelToDevice = (id, deviceId) => ({
  type: EntryActionTypes.LABEL_TO_DEVICE_ADD,
  payload: {
    id,
    deviceId,
  },
});

export const addLabelToCurrentDevice = (id) => ({
  type: EntryActionTypes.LABEL_TO_CURRENT_DEVICE_ADD,
  payload: {
    id,
  },
});

export const removeLabelFromDevice = (id, deviceId) => ({
  type: EntryActionTypes.LABEL_FROM_DEVICE_REMOVE,
  payload: {
    id,
    deviceId,
  },
});

export const removeLabelFromCurrentDevice = (id) => ({
  type: EntryActionTypes.LABEL_FROM_CURRENT_DEVICE_REMOVE,
  payload: {
    id,
  },
});

export const addLabelToFilterInCurrentSite = (id) => ({
  type: EntryActionTypes.LABEL_TO_FILTER_IN_CURRENT_SITE_ADD,
  payload: {
    id,
  },
});

export const removeLabelFromFilterInCurrentSite = (id) => ({
  type: EntryActionTypes.LABEL_FROM_FILTER_IN_CURRENT_SITE_REMOVE,
  payload: {
    id,
  },
});
